export function buildStorageViewUrl(assetKey?: string | null): string {
  const normalizedAssetKey = (assetKey || '').trim();
  if (!normalizedAssetKey) {
    return '';
  }

  return `/api/storage/view?asset_key=${encodeURIComponent(normalizedAssetKey)}`;
}
